import React from "react";
import "./About.css";
import Fade from "react-reveal/Fade";
import mari from "../images/img.jpg";

const About = () => {
  return (
    <div className="about-container" id="about">
      <h2 className="font-heading pt-5 mt-5 text-center">
        <span className="about-title ">About me</span>
      </h2>
      <div className="container my-5 py-5">
        <div className="row d-flex justify-content-center pt-4">
          <div className="col-md-4 offset-md-1 image-div">
            <Fade left>
              <img src={mari} className="mari-image" alt="" />
            </Fade>
          </div>
          <div className="col-md-5  offset-1 font intro flex-class details-div mt-5 mt-md-0">
            <Fade right>
              <p>
                Hi, I am Mariam. A front-end developer from Dhaka,Bangladesh.
              </p>
              <p>
                I love to design and code.I concentrate on writing clean and
                understandable code. Currently, I'm pursuing my undergrads in
                Information and Communication Engineering at Bangladesh
                University of Professionals (BUP). I love to work in a team.
              </p>
              <p>
                Other than coding I like walking in the rain and buying plants.
              </p>
              <p>Connect with me at:</p>
              <div className="social-media">
                <a
                  href="https://www.linkedin.com/in/mariam-chowdhury/"
                  target="_blank"
                >
                  <i class="fab fa-linkedin"></i>
                </a>
                <a href="https://github.com/MariamChowdhury" target="_blank">
                  <i class="fab fa-github"></i>
                </a>

                <a
                  href="https://www.instagram.com/mint___lemon___ade/"
                  target="_blank"
                >
                  <i class="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100015189241148"
                  target="_blank"
                >
                  <i class="fab fa-facebook"></i>
                </a>
                <a href="https://mariamchowdhury.medium.com/" target="_blank">
                  <i class="fab fa-medium"></i>
                </a>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
